import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import ButtonPlusMinus from '../../buttons/ButtonPlusMinus';
import { colorPalette, fonts } from '../../../../styles/styleGuide';
import debounce from 'lodash.debounce';

/*

  This component uses component class for its amount
  because it needs to debounce user input (add and subtract buttons
  invite pushing them multiple times in short order, and we don't
  want to spam the server)

  */
var MultipleSelector = /*#__PURE__*/function (_Component) {
  function MultipleSelector() {
    var _this;
    _classCallCheck(this, MultipleSelector);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MultipleSelector, [].concat(args));
    _defineProperty(_this, "state", {
      amount: _this.props.amount
    });
    _defineProperty(_this, "changeAmount", debounce(function (amount) {
      var props = _this.props;
      if (typeof props.changeHandler === 'function') {
        props.changeHandler(amount);
      }
    }, 500, {
      leading: false,
      trailing: true
    }));
    _defineProperty(_this, "handleAdd", function () {
      _this.setState(function (prevState) {
        return {
          amount: prevState.amount + 1
        };
      }, function () {
        return _this.changeAmount(_this.state.amount);
      });
    });
    _defineProperty(_this, "handleSubtract", function () {
      _this.setState(function (prevState) {
        return {
          amount: prevState.amount > 1 ? prevState.amount - 1 : 0
        };
      }, function () {
        return _this.changeAmount(_this.state.amount);
      });
    });
    _defineProperty(_this, "handleChange", function (event) {
      var value = Number(event.target.value) >= 0 ? event.target.value : 0;
      if (typeof value === 'number') {
        _this.setState(function (prevState) {
          return {
            amount: value
          };
        }, function () {
          _this.changeAmount(_this.state.amount);
        });
      }
    });
    return _this;
  }
  _inherits(MultipleSelector, _Component);
  return _createClass(MultipleSelector, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var amount = this.props.amount;
      if (this.state.amount !== amount) {
        this.setState({
          amount: amount
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        amount = _this$props.amount,
        maxAmount = _this$props.maxAmount;
      return __jsx(Container, {
        "data-id": "fieldTypes_MultipleSelector_Container"
      }, __jsx(ButtonPlusMinus, {
        height: 2.3,
        width: 8,
        type: "subtract",
        clickHandler: !disabled ? this.handleSubtract : undefined,
        disabled: disabled || amount === 0,
        "data-id": "fieldTypes_MultipleSelector_ButtonPlusMinus"
      }), __jsx(AmountInput, {
        type: "number",
        value: this.state.amount,
        readOnly: disabled,
        onChange: !disabled ? this.handleChange : undefined,
        min: 0,
        "data-id": "fieldTypes_MultipleSelector_AmountInput"
      }), __jsx(ButtonPlusMinus, {
        height: 8,
        width: 8,
        type: "add",
        clickHandler: !disabled ? this.handleAdd : undefined,
        disabled: disabled || amount === maxAmount,
        "data-id": "fieldTypes_MultipleSelector_ButtonPlusMinus"
      }));
    }
  }]);
}(Component);
export default MultipleSelector;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 110rem;\n  padding: 10rem;\n  box-sizing: border-box;\n  background: ", ";\n"])), colorPalette.background);
var AmountInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 38rem;\n  box-sizing: border-box;\n  border: solid 1px ", ";\n  margin: 0 5rem;\n  padding: 0 5rem;\n  font-family: ", ";\n  font-size: 14rem;\n  color: ", ";\n  transition: border 0.15s ease-in-out;\n  -moz-appearance: textfield;\n\n  &:focus {\n    outline: 0;\n    border: solid 1rem ", ";\n  }\n  &:read-only:focus {\n    outline: 0;\n    border: solid 1px ", ";\n  }\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n"])), colorPalette.lightGrey, fonts.primary, colorPalette.textGrey, colorPalette.textGrey, colorPalette.lightGrey);